import React from 'react';

import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
} from '@mui/material';
import { Controller } from 'react-hook-form';

/**
 * Item
 */
export type Item = {
  /** ID */
  id: string,
  /** 名前 */
  name: string,
}

/** プロパティ */
export type Props = {
  /** 名前 */
  name: string,
  /** ラベル */
  label: string,
  /** ルール */
  rules: any,
  /** エラー */
  errors: any,
  /** コントロール */
  control: any,
  /** アイテムリスト */
  items: Item[],
  /** 無効か */
  disabled?: boolean,
}

const SelectFieldComp: React.FC<Props> = ({
  control,
  rules,
  name,
  label,
  errors,
  items,
  disabled = false,
}) => {
  const menuItems = items.map(
    (item: Item) => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>,
  );
  return (
    <div style={{ margin: '10px 0' }}>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
        <Controller
          render={({ field }) => (
            <>
              <Select
                label={label}
                value={field.value}
                fullWidth
                onChange={field.onChange}
                error={errors[name] !== undefined}
                disabled={disabled}
              >
                {menuItems}
              </Select>
              <FormHelperText error>
                {errors[name] && errors[name].message}
              </FormHelperText>
            </>
          )}
          name={name}
          control={control}
          rules={rules}
        />
      </FormControl>
    </div>
  );
};

export default SelectFieldComp;
